import React from "react";

interface LoaderProps {
  isGrey?: boolean;
}

export const Loader: React.FC<LoaderProps> = () => {
  return (
    <svg
      width="32"
      className="animate-loader-circle"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="animate-loader"
        d="M14 29.6673C21.3638 29.6673 27.3333 23.6977 27.3333 16.3339C27.3333 8.97015 21.3638 3.00061 14 3.00061"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        className="animate-loader"
        d="M22 16.334C22 20.7523 18.4183 24.334 14 24.334C9.58172 24.334 6 20.7523 6 16.334"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        className="animate-loader"
        d="M14 19.334C12.3431 19.334 11 17.9908 11 16.334C11 14.6771 12.3431 13.334 14 13.334"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
};
